import { useEffect, useState } from "react";
import { useHistory } from "react-router";

const useNotificationDropdown = () => {
  const [isDropdownOpen, setIsOpen] = useState(false);
  const history = useHistory();

  const toggleNotificationDropdown = () => {
    setIsOpen((prevState) => !prevState);
  };

  const toNotifications = () => {
    history.push("/my-notifications");
  };

  useEffect(() => {
    setIsOpen(false);
  }, [history.location.pathname]);

  const onEscape = (e) => {
    if (e.key === "Escape") {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isDropdownOpen) {
      document.addEventListener("keydown", onEscape);
    } else {
      document.removeEventListener("keydown", onEscape);
    }
  }, [isDropdownOpen]);

  return { isDropdownOpen, toggleNotificationDropdown, toNotifications };
};

export default useNotificationDropdown;
